type StatusMessageProps = {
  message?: string
  variant: 'danger' | 'warning' | 'success'
}

export const StatusMessage = ({ message, variant }: StatusMessageProps) => {
  if (!message) return null
  const colorMap = {
    danger: 'ap:text-content-danger',
    warning: 'ap:text-yellow-500',
    success: 'ap:text-content-success',
  }
  return <span className={`ap:text-sm ${colorMap[variant]}`}>{message}</span>
}
